import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { getDurationInMonths } from '@helpers/GetDurationInMonths/getDurationInMonths';
import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

export const FullTermDurationRow = ({
    selectedOffer
}: {
    selectedOffer: TFormalOffer | undefined;
}) => {
    const fullTermMonths = selectedOffer?.duration
        ? getDurationInMonths(selectedOffer.duration)
        : null;

    return (
        <div className="flex items-center justify-between">
            <Text>
                <FormattedMessage
                    id="_.loan_summary.full_term_duration"
                    defaultMessage="Full term duration:"
                />
            </Text>
            <Text className="font-bold">
                {fullTermMonths !== null ? (
                    <FormattedMessage
                        id="_.loan_summary.full_term_months"
                        defaultMessage="{months} months"
                        values={{ months: fullTermMonths }}
                    />
                ) : (
                    <FormattedMessage
                        id="_.loan_summary.full_term_months_placeholder"
                        defaultMessage="-- months"
                    />
                )}
            </Text>
        </div>
    );
};
